module.exports = __webpack_public_path__ + "img/forgot-password-v2.ab4fa84c.svg";